import { Tab, Tabs } from "@mui/material";
import { toStdDate } from "../../utils/dates";

const VenueTabs = ({dayEvents, selectedVenueTab, handleTabChange}) => {

  console.log("DEBUG: VenueTabs.jsx: VenueTabs: dayEvents: ", dayEvents)

    return (
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        value={selectedVenueTab}
        onChange={handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
        TabIndicatorProps={{ sx: { display: "none" } }}
        sx={{
          margin: "0 0 1em 0",
          ".Mui-selected": {
            color: `var(--orange)`,
            fontWeight: "700",
          },
          "& .MuiTabs-flexContainer": {
            flexWrap: "wrap",
          },
        }}
      >
        {dayEvents?.map((v, i) => (
          <Tab
            label={
              v?.event?.name.substring(0, 20) +
              "@" +
              v?.event?.venue?.name?.substring(0, 20) +
              " " +
              toStdDate(v?.event?.date)
            }
            key={`venuetab-${i}`}
            value={v.bteId}
          />
        ))}
      </Tabs>
    );
  };

export default VenueTabs;